<template>
  <v-bottom-navigation
    v-if="$vuetify.breakpoint.smAndDown && showMobileNav"
    class="align-center no-print"
    color="primary"
    app
    clipped-right
    grow
  >
    <v-btn
      :to="{ name: 'home' }"
      class="footer-buttons"
    >
      <span>{{ $t("menu.home") }}</span>
    </v-btn>
    <v-btn
      v-if="$auth.isAuthenticated && $auth.user.email_verified"
      :to="{ name: 'bookshelf' }"
      class="footer-buttons"
    >
      <span>{{ $t("menu.bookshelf") }}</span>
    </v-btn>
    <v-btn
      v-if="$auth.isAuthenticated && isAdmin"
      :to="{ name: 'schoolBookLists' }"
      class="footer-buttons"
    >
      <span style="line-clamp: 2">
        {{ $t("menu.schoolBookLists") }}
      </span>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
import { mapGetters } from "vuex";
import AdminCheckMixin from "@/mixins/AdminCheckMixin";
export default {
  name: "MobileNav",
  mixins: [AdminCheckMixin],
  computed: {
    ...mapGetters("siteSettings", ["showMobileNav"]),
  },
};
</script>

<style scoped lang="scss">
@import "~vuetify/src/styles/styles.sass";

.v-btn.footer-buttons {
  height: 100%;
}
</style>

